/*! hash:0358d20f1646417a5caf, chunkhash:1d415a392979b1130812, name:index/index, filebase:index.1d415a392.js, query:, file:assets/js/index/index.1d415a392.js */
webpackJsonp([5],{

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(10);

var _sweetalert = __webpack_require__(1);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 取得完整的 URL
var url = new URL(window.location.href);
// 解析 URL 中的參數
var searchParams = new URLSearchParams(url.search);
// 取得 agent 參數的值
var agentValue = searchParams.get('agent');

var has_agent = ['test', 'lucifer01', 'JP8', 'fans', 'say', 'mama', 'aAgent', 'bAgent', 'cAgent', 'dAgent', 'dAgent2', 'dAgent3'];
if (searchParams.has('agent') && has_agent.indexOf(agentValue) === -1) {
    (0, _sweetalert2.default)({
        title: '請檢查代理網址!',
        text: '此代理網址為非法註冊，請聯絡客服！',
        type: 'error',
        confirmButtonText: '確認'
    });
}

$("#register-submit").click(function (event) {
    event.preventDefault();
    send('register', {
        "account": document.getElementById('register-account').value,
        "password": document.getElementById('register-password').value,
        "name": document.getElementById('register-name').value,
        "agent": agentValue
    });
});

$("#submit").click(function (event) {
    event.preventDefault();
    send('login', {
        "account": document.getElementById('account').value,
        "password": document.getElementById('password').value
    });
});

function send(url, data) {
    var errorMsg = '請填寫正確帳密或使用ＦＢ進行登入';
    if (url === 'register') {
        errorMsg = '註冊異常，請再次註冊！如無法順利完成請聯絡客服。';
    }

    // fetch(`http://fbpoke.com/php/${url}.php`, {
    fetch("https://qq588.cc/" + 'php/' + url + '.php', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'content-type': 'application/json'
        },
        dataType: 'json',
        body: JSON.stringify(data)
    }).then(function (response) {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
    }).then(function (item) {
        if (item.msg === 'error') {
            (0, _sweetalert2.default)('註冊資料規則異常，請正確填寫資料。', item, 'error');
        } else if (item.msg === 'error_1') {
            (0, _sweetalert2.default)('帳號已註冊！', item, 'error');
        } else {
            item.status = 'DB';
            statusChangeCallback(item);
        }
    }).catch(function (error) {
        console.log(error);
        (0, _sweetalert2.default)(errorMsg, error, 'error');
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[16]);


// WEBPACK FOOTER //
// assets/js/index/index.1d415a392.js